import { useTranslation } from 'react-i18next'

import { Skeleton } from '@/components/ui'

export const CadastroClienteSkeleton = () => {
  const { t } = useTranslation('clientes')
  return (
    <div className="space-y-4 p-4" data-testid="cadastrar-cliente-skeleton">
      <div className="br-12 mx-auto w-full space-y-8 sm:max-w-4xl">
        <h1 className="text-xl uppercase">{t('cadastrar_cliente.titulo')}</h1>
        <div className="bg-foreground border-muted space-y-8 rounded-sm rounded-b-none border-b-1 p-6 shadow-xs">
          <Skeleton className="mb-6 h-6 w-64" />
          <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-32" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-48" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
            <div className="flex flex-col gap-2">
              <Skeleton className="h-5 w-24" />
              <Skeleton className="h-10 w-full rounded-md" />
            </div>
          </div>
          <div className="mt-11 flex justify-end gap-4">
            <Skeleton className="h-10 w-30 rounded-md" />
            <Skeleton className="h-10 w-44 rounded-md" />
          </div>
        </div>
      </div>
    </div>
  )
}
